import type { TFunction } from 'i18next';
import type { Dokumenttype } from '@origo/planregister';
import type { SelectOption } from '../types';

const CODES: Dokumenttype[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '99'];

export function dokumenttypeLabel(code: Dokumenttype | string | undefined, t: TFunction): string {
    if (!code) return t('codelists.dokumenttype.unknown', { defaultValue: '' });
    return t(`codelists.dokumenttype.${code}`, { defaultValue: code });
}

export function dokumenttypeOptions(t: TFunction): SelectOption[] {
    return CODES.map(code => ({ value: code, label: dokumenttypeLabel(code, t) }));
}
